import { Inject, Injectable } from '@angular/core';
import { IFilterService, IScopedFormsResponse } from './service.class';
import { HttpClient } from '@angular/common/http';
import { IScopedFormDropdownData } from '../../component/filter/filter.class';

@Injectable({
  providedIn: 'root',
})
export class ScopedFormService implements IFilterService {
  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  private readonly routes: string = 'forms/versions-logbook-assignments';

  getScopedForms(): Promise<IScopedFormDropdownData[]> {
    return this.getData();
  }

  public getData(): Promise<IScopedFormDropdownData[]> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      this.http.get(`${this.baseUrl}/${this.routes}`).subscribe((response: IScopedFormsResponse) => {
        if (response.hasOwnProperty('data')) {
          resolve(response.data);
        } else {
          reject();
        }
      });
    });
  }
}
